import { useSyncExternalStore } from 'react'
import { Store } from './tron'

export const useAppkit = () =>
  useSyncExternalStore(Store.on, () => Store.value)
